import {messages as de} from "./de"
import {messages as en} from "./en"

export default {
	en: en,
	de: de
};
